var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBooksAndLiterature = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Book-Library-Shelf-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Book Library Shelf 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 0a1 1 0 0 0 -1 1v6a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1V1a1 1 0 0 0 -2 0v12.5a2.25 2.25 0 0 0 2.25 2.25h2.5A2.25 2.25 0 0 0 24 13.5V1a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.87 16.73a0.28 0.28 0 0 0 -0.25 0 3.6 3.6 0 0 1 -1.87 0.52h-2.5a3.6 3.6 0 0 1 -1.87 -0.52 0.28 0.28 0 0 0 -0.25 0A0.26 0.26 0 0 0 17 17v4a3 3 0 0 0 3 3h1a3 3 0 0 0 3 -3v-4a0.26 0.26 0 0 0 -0.13 -0.27ZM21 21.25h-1a1.25 1.25 0 0 1 0 -2.5h1a1.25 1.25 0 0 1 0 2.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0a1 1 0 0 0 -1 1v6a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1V1a1 1 0 0 0 -2 0v12.5a2.25 2.25 0 0 0 2.25 2.25h2.5a2.25 2.25 0 0 0 2.25 -2.25V1a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.37 16.73a0.28 0.28 0 0 0 -0.25 0 3.6 3.6 0 0 1 -1.87 0.52h-2.5a3.6 3.6 0 0 1 -1.87 -0.52 0.28 0.28 0 0 0 -0.25 0 0.26 0.26 0 0 0 -0.13 0.27v4a3 3 0 0 0 3 3h1a3 3 0 0 0 3 -3v-4a0.26 0.26 0 0 0 -0.13 -0.27Zm-2.87 4.52h-1a1.25 1.25 0 0 1 0 -2.5h1a1.25 1.25 0 0 1 0 2.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0a1 1 0 0 0 -1 1v6a1 1 0 0 1 -1 1H3a1 1 0 0 1 -1 -1V1a1 1 0 0 0 -2 0v12.5a2.25 2.25 0 0 0 2.25 2.25h2.5A2.25 2.25 0 0 0 7 13.5V1a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87 16.73a0.28 0.28 0 0 0 -0.25 0 3.6 3.6 0 0 1 -1.87 0.52h-2.5a3.6 3.6 0 0 1 -1.87 -0.52 0.28 0.28 0 0 0 -0.25 0A0.26 0.26 0 0 0 0 17v4a3 3 0 0 0 3 3h1a3 3 0 0 0 3 -3v-4a0.26 0.26 0 0 0 -0.13 -0.27ZM4 21.25H3a1.25 1.25 0 0 1 0 -2.5h1a1.25 1.25 0 0 1 0 2.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBooksAndLiterature);
export default ForwardRef;